var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.496 1-.317 1.025v29.748l.317.302 14.495-8.163L23.496 1Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.496 1 9 23.912l14.496 8.163V1Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.496 34.69-.179.206v10.597l.179.497L38 26.53l-14.504 8.16Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.496 45.99V34.689L9 26.531 23.496 45.99Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.496 32.075 14.495-8.163-14.495-6.276v14.439Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 23.912 14.495 8.163v-14.44L9 23.913Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "47_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 1)",
    d: "M0 0h29v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.7cc3ae793afddf32206c77e493b310a7.svg";
export { ForwardRef as ReactComponent };